module.exports = __webpack_public_path__ + "static/media/month_10.38926b0b.png";